"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResource = exports.NetworkStatus = exports.FetchPolicy = void 0;
var _provider = require("@clayui/provider");
var _shared = require("@clayui/shared");
var _react = require("react");
var _warning = _interopRequireDefault(require("warning"));
var _util = require("./util");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var FetchPolicy;
/**
 * - Loading (1) The status is set to `loading` only when the first
 *   requisition occurs.
 * - Refetch (2) The status is set to `refetch` when a change in the variables API
 *   or refetch method is called.
 * - Polling (3) The status is set to `polling` when pollInterval is set above 0.
 * - Unused (4) When no request is happening the status will be `unused`.
 * - Error (5) When any timeout or request `error` occurs, the status will be set
 *   to error.
 */
(function (FetchPolicy) {
  FetchPolicy["CacheFirst"] = "cache-first";
  FetchPolicy["NoCache"] = "no-cache";
  FetchPolicy["CacheAndNetwork"] = "cache-and-network";
})(FetchPolicy || (exports.FetchPolicy = FetchPolicy = {}));
var NetworkStatus;
(function (NetworkStatus) {
  NetworkStatus[NetworkStatus["Error"] = 5] = "Error";
  NetworkStatus[NetworkStatus["Loading"] = 1] = "Loading";
  NetworkStatus[NetworkStatus["Polling"] = 3] = "Polling";
  NetworkStatus[NetworkStatus["Refetch"] = 2] = "Refetch";
  NetworkStatus[NetworkStatus["Unused"] = 4] = "Unused";
})(NetworkStatus || (exports.NetworkStatus = NetworkStatus = {}));
var idCounter = 0;
var useResource = exports.useResource = function useResource(_ref) {
  var _client$current$read;
  var fetcher = _ref.fetch,
    _ref$fetchDelay = _ref.fetchDelay,
    fetchDelay = _ref$fetchDelay === void 0 ? 300 : _ref$fetchDelay,
    fetchOptions = _ref.fetchOptions,
    _ref$fetchPolicy = _ref.fetchPolicy,
    fetchPolicy = _ref$fetchPolicy === void 0 ? FetchPolicy.NoCache : _ref$fetchPolicy,
    _ref$fetchRetry = _ref.fetchRetry,
    fetchRetry = _ref$fetchRetry === void 0 ? {} : _ref$fetchRetry,
    _ref$fetchTimeout = _ref.fetchTimeout,
    fetchTimeout = _ref$fetchTimeout === void 0 ? 6000 : _ref$fetchTimeout,
    link = _ref.link,
    _ref$onNetworkStatusC = _ref.onNetworkStatusChange,
    onNetworkStatusChange = _ref$onNetworkStatusC === void 0 ? function () {} : _ref$onNetworkStatusC,
    _ref$pollInterval = _ref.pollInterval,
    pollInterval = _ref$pollInterval === void 0 ? 0 : _ref$pollInterval,
    storageMaxSize = _ref.storageMaxSize,
    _ref$suspense = _ref.suspense,
    suspense = _ref$suspense === void 0 ? false : _ref$suspense,
    _ref$variables = _ref.variables,
    variables = _ref$variables === void 0 ? null : _ref$variables;
  // We changed the cache policy when suspense is enabled so that the
  // integration with suspense and the client works better, we need
  // to store the data that was retrieved from the promise in progress
  // on the client and then get it again to fill in the hook.
  // When we throw the promise at render time, suspense invokes and resets
  // the hook states and refs every time, when realizes the promise has been
  // resolved starts the hooks lifecycle with useEffects and other states.
  if (fetchPolicy === FetchPolicy.NoCache && suspense) {
    fetchPolicy = FetchPolicy.CacheAndNetwork;
  }
  var pollingTimeoutIdRef = (0, _react.useRef)(null);
  var retryDelayTimeoutIdRef = (0, _react.useRef)(null);
  var abortController = (0, _react.useRef)(null);
  var networkStatusRef = (0, _react.useRef)();
  var pollIntervalRef = (0, _react.useRef)(pollInterval);
  var uid = (0, _react.useMemo)(function () {
    idCounter++;
    return String(idCounter);
  }, []);

  // A flag to identify if the first rendering happened to avoid
  // two requests.
  var firstRenderRef = (0, _react.useRef)(true);
  var firstRequestRef = (0, _react.useRef)(false);
  var shouldUseCache = fetchPolicy === FetchPolicy.CacheFirst || fetchPolicy === FetchPolicy.CacheAndNetwork;
  var identifier = (0, _react.useMemo)(function () {
    if (typeof link === 'string') {
      return (0, _util.getIdentifier)(link, variables, fetchOptions);
    }
    return uid;
  }, [link, variables, fetchOptions]);
  var _useProvider = (0, _provider.useProvider)(),
    globalClient = _useProvider.client;
  var client = (0, _react.useRef)(globalClient !== null && globalClient !== void 0 ? globalClient : new _provider.__UNSTABLE_DataClient({
    storageMaxSize: storageMaxSize
  }));
  "production" !== "production" ? (0, _warning.default)(!(suspense && typeof globalClient === 'undefined'), 'DataProvider: for the integration with Suspense to work correctly, the ClayProvider must be declared at the root of the project.') : void 0;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    sort = _useState2[0],
    setSort = _useState2[1];
  var _useState3 = (0, _react.useState)((_client$current$read = client.current.read(identifier)) !== null && _client$current$read !== void 0 ? _client$current$read : null),
    _useState4 = _slicedToArray(_useState3, 2),
    resource = _useState4[0],
    setResource = _useState4[1];
  var debouncedVariablesChange = (0, _shared.useDebounce)(variables, fetchDelay);
  var dispatchNetworkStatus = function dispatchNetworkStatus(status) {
    onNetworkStatusChange(status);
    networkStatusRef.current = status;
  };
  var cleanRetry = function cleanRetry() {
    if (retryDelayTimeoutIdRef.current) {
      clearTimeout(retryDelayTimeoutIdRef.current);
    }
  };
  var getRetryDelay = function getRetryDelay(retryAttempts) {
    var _fetchRetry$delay = fetchRetry.delay,
      delay = _fetchRetry$delay === void 0 ? {} : _fetchRetry$delay;
    var _delay$initial = delay.initial,
      initial = _delay$initial === void 0 ? 300 : _delay$initial,
      _delay$jitter = delay.jitter,
      jitter = _delay$jitter === void 0 ? true : _delay$jitter;
    var baseDelay = jitter ? initial : initial / 2;
    var value = baseDelay * Math.pow(2, retryAttempts);
    if (jitter) {
      value = Math.random() * value;
    }
    return value;
  };
  var handleFetchRetry = function handleFetchRetry(error, retryAttempts) {
    var _fetchRetry$attempts = fetchRetry.attempts,
      attempts = _fetchRetry$attempts === void 0 ? 5 : _fetchRetry$attempts;
    cleanRetry();
    if (attempts > 0 && retryAttempts < attempts) {
      var delay = getRetryDelay(retryAttempts);

      // eslint-disable-next-line no-console
      console.warn("DataProvider: Trying ".concat(retryAttempts + 1, " of ").concat(attempts, " will happen in ").concat(delay, "ms"));
      retryDelayTimeoutIdRef.current = setTimeout(function () {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        doFetch(retryAttempts + 1);
      }, delay);
    } else {
      if (suspense) {
        client.current.update(identifier, error);
      } else {
        dispatchNetworkStatus(NetworkStatus.Error);
      }
      "production" !== "production" ? (0, _warning.default)(false, "DataProvider: Error making the requisition ".concat(error)) : void 0;
    }
  };
  var cleanPoll = function cleanPoll() {
    return pollingTimeoutIdRef.current && clearTimeout(pollingTimeoutIdRef.current);
  };
  var setPoll = function setPoll() {
    cleanPoll();
    pollingTimeoutIdRef.current = setTimeout(function () {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      maybeFetch(NetworkStatus.Polling);
    }, pollIntervalRef.current);
  };
  var fetchOnComplete = function fetchOnComplete(result) {
    // Should clear retry interval if any of the
    // attempts are successful.
    cleanRetry();
    var data = result;
    var cursor = client.current.getCursor(identifier);
    if (networkStatusRef.current === NetworkStatus.Loading && (cursor || cursor === null) && resource !== null && resource !== undefined) {
      if (Array.isArray(result) && Array.isArray(resource)) {
        data = [].concat(_toConsumableArray(resource), _toConsumableArray(result));
      } else if (_typeof(result) === 'object' && _typeof(resource) === 'object') {
        data = _objectSpread(_objectSpread({}, resource), result);
      }
    }
    setResource(data);
    dispatchNetworkStatus(NetworkStatus.Unused);
    if (shouldUseCache) {
      client.current.update(identifier, data);
    }
    if (pollIntervalRef.current > 0) {
      setPoll();
    }
    return result;
  };
  var populateSearchParams = function populateSearchParams(uri, variables) {
    if (!variables) {
      return uri;
    }
    var keys = Object.keys(variables);
    keys.forEach(function (key) {
      return uri.searchParams.set(key, variables[key]);
    });
    return uri;
  };
  var getUrlFormat = function getUrlFormat(link, variables) {
    var uri = new URL(link);
    if (client.current.getCursor(identifier) === null) {
      "production" !== "production" ? (0, _warning.default)(uri.searchParams.toString() === '', 'DataProvider: We recommend that instead of passing parameters over the link, use the variables API. \n More details: https://clayui.com/docs/components/data-provider.html') : void 0;
    }
    if (!variables) {
      return uri.toString();
    }
    populateSearchParams(uri, variables);
    return uri.toString();
  };
  var doFetch = function doFetch() {
    var retryAttempts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var doSort = arguments.length > 1 ? arguments[1] : undefined;
    "production" !== "production" ? (0, _warning.default)(typeof link === 'string', 'DataProvider: The behavior of the `link` accepting a function has been deprecated in favor of the `fetcher` API. \n More details: https://clayui.com/docs/components/data-provider.html#data-fetching') : void 0;
    switch (_typeof(link)) {
      case 'function':
        return (0, _util.timeout)(fetchTimeout, link(populateSearchParams(
        // This is just a hack to be able to instantiate the URL and make
        // `populateSearchParams` reusable in `getUrlFormat` and make
        // things easier.
        new URL('http://clay.data.provider'), variables).searchParams.toString())).then(fetchOnComplete).catch(function (error) {
          return handleFetchRetry(error, retryAttempts);
        });
      case 'string':
        {
          var _client$current$getCu;
          var fn = fetcher !== null && fetcher !== void 0 ? fetcher : fetch;
          var nextCursor = undefined;
          if (abortController.current) {
            abortController.current.abort();
          }
          abortController.current = new AbortController();
          return (0, _util.timeout)(fetchTimeout, fn(getUrlFormat((_client$current$getCu = client.current.getCursor(identifier)) !== null && _client$current$getCu !== void 0 ? _client$current$getCu : link, variables), _objectSpread(_objectSpread({}, fetchOptions), {}, {
            signal: abortController.current.signal
          }), doSort || sort || undefined), abortController.current).then(function (res) {
            if (res instanceof Response && res.ok && !res.bodyUsed) {
              return res.json();
            } else if (!(res instanceof Response) && res.items && (res.cursor || res.cursor === null)) {
              nextCursor = res.cursor;
              return res.items;
            }
            return res;
          }).then(fetchOnComplete).then(function (res) {
            if (nextCursor !== undefined) {
              client.current.setCursor(identifier, nextCursor);
            }
            return res;
          }).catch(function (error) {
            return handleFetchRetry(error, retryAttempts);
          });
        }
      default:
        return null;
    }
  };
  var maybeFetch = function maybeFetch(status) {
    var data = client.current.read(identifier);
    if (shouldUseCache && data) {
      fetchOnComplete(data);

      // When fetch policy is only cache-first and gets the data from
      // the cache, it should not perform a request, only when it is
      // cache-and-network.
      if (fetchPolicy === FetchPolicy.CacheFirst) {
        return false;
      }
    }
    dispatchNetworkStatus(status);
    return doFetch();
  };
  var loadMore = function loadMore() {
    if (!client.current.getCursor(identifier)) {
      return null;
    }
    dispatchNetworkStatus(NetworkStatus.Loading);
    return doFetch();
  };
  var refetch = function refetch() {
    if (!shouldUseCache) {
      // Resets the cursor
      delete client.current.cursors[identifier];
    }
    dispatchNetworkStatus(NetworkStatus.Refetch);
    doFetch();
  };
  var onSortChange = function onSortChange(sort) {
    setSort(sort);
    doFetch(0, sort);
  };
  (0, _react.useEffect)(function () {
    pollIntervalRef.current = pollInterval;
    if (pollInterval > 0) {
      setPoll();
    }
  }, [pollInterval]);
  (0, _react.useEffect)(function () {
    if (!firstRenderRef.current) {
      if (!shouldUseCache) {
        // Resets the cursor
        delete client.current.cursors[identifier];
      }
      maybeFetch(NetworkStatus.Refetch);
    }
  }, [debouncedVariablesChange]);
  (0, _react.useEffect)(function () {
    firstRenderRef.current = false;
    return function () {
      // Set to zero to prevent any unfinished requests
      // from continuing polling after umount has occurred.
      pollIntervalRef.current = 0;
      cleanPoll();
      cleanRetry();
    };
  }, []);
  var fetchingOrError = client.current.isFetching(identifier);

  // Makes first request if not started at render time
  if (!fetchingOrError && firstRenderRef.current) {
    var result = maybeFetch(NetworkStatus.Loading);
    if (result) {
      firstRequestRef.current = true;
      fetchingOrError = result;
      client.current.update(identifier, result);
    }
  }

  // Attach the promise to the instance if it is not the that started
  // the request.
  if (fetchingOrError && firstRequestRef.current === false && !suspense) {
    firstRequestRef.current = true;
    if (fetchingOrError instanceof Promise) {
      fetchingOrError.then(fetchOnComplete);
    }
  }

  // Integration with React.Suspense
  if (suspense && resource === null && (fetchingOrError instanceof Promise || fetchingOrError instanceof Error)) {
    // Integration with React.Suspense, throwing a throw with the promise in
    // progress at render time for Suspense to catch.
    // Integration with ErrorBoundary, when a network error happens we throw
    // an error at render time so that ErrorBoundary catches the error.
    throw fetchingOrError;
  }
  return {
    loadMore: loadMore,
    refetch: refetch,
    resource: resource,
    sort: sort,
    sortChange: onSortChange
  };
};